import React, { use, useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { deletes, get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  arrow_icon,
  delete_icon,
  drag,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../assets/img";

const TutorialCategories = () => {
  const [show, setShow] = useState(false);
  const [active, setActive] = useState("User");
  const [list, setList] = useState({ User: [], Hotels: [] });

  const [selected, setSelected] = useState(false);
  const [deleteGroup, setDeleteGroup] = useState(false);
  const [category, setCategory] = useState("");
  const [groupNames, setGroupNames] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const [groupName, setGroupName] = useState({});
  const [search, setSearch] = useState("");
  const imgRef = useRef(null);

  //drag and drop
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const handleSort = () => {
    let items = [...list?.[active]];
    const draggedItemContent = items.splice(dragItem.current, 1)[0];
    items.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setList((prev) => ({ ...prev, [active]: items }));
    if (items.length > 1) setShow(true);
  };

  const handleGroupSort = () => {
    let items = [...groupNames];
    const draggedItemContent = items.splice(dragItem.current, 1)[0];
    items.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setGroupNames(items);
  };

  const onAdd = (e) => {
    e.preventDefault();
    let trimmed = groupName?.name.trim();
    if (trimmed !== "") {
      setGroupNames((prev) => [...prev, { ...groupName, name: trimmed }]);
      setGroupName({});
    }
  };

  const handleRemove = async (index, item) => {
    setGroupNames((prev) => prev.filter((_, ind) => ind != index));
    setDeleteGroup(false);
    if (item?.id) setDeletedIds((prev) => [...prev, item?.id]);
  };

  const handleGroupEdit = (data) => {
    setGroupNames((prev) => [
      ...(Object.keys(groupName).length !== 0 ? [groupName] : []),
      ...prev.filter((item) => item?.id !== data?.id),
    ]);
    setGroupName(data);
  };
  console.log("group names", groupNames);
  const handleClosePop = () => {
    setSelected(false);
    setGroupName({});
    setCategory("");
    setGroupNames([]);
    setDeletedIds([]);
  };

  const handleFilter = (data, search) => {
    if (!search || !data) return data ?? [];
    let filtered = (data ?? []).filter((item) =>
      item?.name?.toUpperCase().includes(search?.toUpperCase()),
    );

    if (filtered?.length === 0) toast.info("No Records Found..");
    return filtered;
  };

  //api functions

  const getList = async () => {
    let res = await get(
      `${URLS.VIDEO_CATEGORY_LIST}?type=${active === "User" ? 1 : 2}`,
    );
    if (res?.status === "success") {
      setList((prev) => ({ ...prev, [active]: res?.data }));
    }
  };

  useEffect(() => {
    sessionStorage.setItem("tutorial_videos_active_tab", "2");
    getList();
    setShow(false);
  }, [active]);

  const savePosition = async (data) => {
    console.log("save position", data, list[active]);
    const payload = (data ?? list[active])?.map((item, index) => ({
      id: item.id,
      position: index + 1,
    }));
    const res = await post(`${URLS.VIDEO_CATEGORY_POSITION}`, payload);
    if (res?.status === "success") {
      toast.success(res?.message || "Position updated");
      setShow(false);
    }
  };

  const handleSubmit = async () => {
    let data = selected?.data;
    if (!data?.name || groupNames?.length == 0) {
      toast.error(
        !data?.name ? "add the Category name" : "add atleast one Group name",
      );
      return;
    }

    let isAdd = selected?.type === "add";
    let url = isAdd
      ? URLS.VIDEO_CATEGORY_CREATE
      : URLS.VIDEO_CATEGORY_EDIT + data?.id + "/";
    let method = isAdd ? post : put;
    let payload = new FormData();
    payload.append("type", active === "User" ? 1 : 2);
    payload.append("name", data?.name);
    payload.append("category_image", data?.category_image);

    let catRes = await method(url, payload);
    if (catRes?.status === "success") {
      groupEdit(catRes?.data ?? selected?.data);
    }
  };

  const groupEdit = async (data) => {
    let isAdd = selected?.type === "add";

    let groupUrl = URLS.VIDEO_CATEGORY_GROUP_EDIT;
    let groupPayload = {
      parent_id: data?.id,
      deleted_ids: deletedIds,
      name: groupNames.map((item, index) => ({
        ...item,
        status: item?.status ? 1 : 0,
        position: index + 1,
      })),
    };
    let groupRes = await put(groupUrl, groupPayload);
    if (groupRes?.status === "success") {
      toast.success(
        groupRes?.message || isAdd
          ? "Category Created Successfully"
          : "Category Edited Successfully",
      );
      getList();
      handleClosePop();
    }
  };

  const handleStatus = async (d) => {
    let res = await put(`${URLS.VIDEO_CATEGORY_STATUS}${d.id}/`);
    if (res?.status === "success") {
      toast.success(res?.message);
      setList((prev) => ({
        ...prev,
        [active]: prev?.[active].map((item) =>
          item?.id === d?.id ? { ...item, status: !d?.status } : item,
        ),
      }));
    }
  };

  const handleDelete = async (data) => {
    let res = await deletes(URLS.VIDEO_CATEGORY_DELETE + data?.id + "/");
    if (res?.status === "success") {
      setList((prev) => ({
        ...prev,
        [active]: prev?.[active]?.filter((item) => item?.id != data?.id),
      }));
      toast.success(res?.message);
      handleClosePop();
    }
  };

  return (
    <div>
      <Topbar header={"Video Category"} back={true} />
      <div className="d-flex ac-jb">
        <div className="d-flex gap-3">
          {["User", "Hotels"].map((ele) => {
            return (
              <div
                key={ele}
                style={{
                  background: active == ele ? "#AE55F5" : "#78788029",
                  padding: "10px 30px",
                  borderRadius: 7,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setActive(ele);
                }}
              >
                <p style={{ color: active == ele ? "#fff" : "#000" }}>{ele}</p>
              </div>
            );
          })}
        </div>

        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          <button
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
            onClick={() => {
              if (active !== "User") setSelected({ type: "add" });
            }}
            style={{
              fontSize: "12px",
              opacity: active === "User" ? 0.3 : 1,
              cursor: active === "User" ? "default" : "pointer",
            }}
          >
            + Add Category
          </button>
          {show && (
            <button
              onClick={() => savePosition()}
              className="submit-btn f2"
              style={{ minWidth: "120px" }}
            >
              Save
            </button>
          )}
        </div>
      </div>

      <h2 className="f1 mt-3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
        Total No: {String(list?.[active]?.length ?? 0).padStart(2, 0)}
      </h2>
      {/* Table */}
      <div className="mt-3" style={{ width: "100%", overflow: "auto" }}>
        <table
          className="table-design-new"
          style={{ width: "98%", borderRadius: "10px" }}
        >
          <thead>
            <tr className="border-bottom w-100">
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                S.No
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                category
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Group Videos Name
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Status
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {handleFilter(list?.[active], search)?.map((item, index) => (
              <tr
                key={index}
                className="list-item p-2"
                // draggable
                onDragStart={() => (dragItem.current = index)}
                onDragEnter={() => (dragOverItem.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
              >
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 red list-data ">
                  {index + 1}
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item?.name}
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  <p className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16  gray2 list-data">
                    {item?.group_count} Groups
                  </p>
                </td>
                <td className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  <button
                    onClick={() => {
                      if (active !== "User") handleStatus(item);
                    }}
                    className={item.status ? "active-btn" : "deactive-btn"}
                    style={{
                      fontSize: "12px",
                      opacity: active === "User" ? 0.3 : 1,
                      cursor: active === "User" ? "default" : "pointer",
                    }}
                  >
                    {item.status ? "Active" : "De-active"}
                  </button>
                </td>
                <td>
                  <div className="d-flex ac-js gap-2">
                    <button
                      onClick={() => {
                        setGroupNames(item?.groups);
                        setSelected({ type: "edit", data: item });
                      }}
                      className="cust-btn "
                    >
                      <img src={edit_icon} alt="" className="edit-btn" />
                    </button>

                    {active !== "User" && (
                      <button
                        onClick={() =>
                          setSelected({ type: "delete", data: item })
                        }
                        className="cust-btn "
                      >
                        <img src={delete_icon} alt="" className="edit-btn" />
                      </button>
                    )}
                  </div>
                </td>
                <td className="position-relative">
                  <div className="drag-box">
                    <img src={drag} className="drag-img" alt="" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* popup  */}
      {Boolean(selected?.type === "add" || selected.type === "edit") && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {selected?.type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  handleClosePop();
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="col-md-6">
                  <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
                    Max Upload Size : 5MB and Banner Size 1200px 700px, Max 10
                    image*
                  </p>
                  <div className="d-flex flex-column as-jc position-relative">
                    <img
                      onClick={() => imgRef.current?.click()}
                      src={
                        selected?.data?.category_image
                          ? typeof selected?.data?.category_image === "string"
                            ? selected?.data?.category_image
                            : URL.createObjectURL(
                                selected?.data?.category_image,
                              )
                          : dummyimage
                      }
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50px",
                      }}
                      alt=""
                    />
                    <input
                      ref={imgRef}
                      type="file"
                      className="input-pop mt-2 w-100 d-none"
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length > 0) {
                          setSelected((prev) => ({
                            ...prev,
                            data: {
                              ...prev.data,
                              category_image: e.target.files[0],
                            },
                          }));
                        }
                      }}
                    />
                  </div>
                </div>

                <div>
                  <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                    Category Name
                  </h3>
                  <div className="d-flex ae-jb input-border p-1 mb-1">
                    <input
                      type="text"
                      value={selected?.data?.name}
                      onChange={(e) => {
                        setSelected((prev) => ({
                          ...prev,
                          data: { ...prev.data, name: e.target.value },
                        }));
                      }}
                      placeholder="category name"
                      className="input-box"
                    />
                  </div>

                  <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                    Group Names
                  </h3>
                  <div className="d-flex ae-jb input-border p-1">
                    <textarea
                      style={{ maxHeight: "50px" }}
                      value={groupName?.name ?? ""}
                      onChange={(e) => {
                        setGroupName((prev) => ({
                          ...prev,
                          ...(typeof prev?.status === "boolean"
                            ? { name: e.target.value }
                            : { name: e.target.value, status: true }),
                        }));
                      }}
                      placeholder="Write Here...."
                      className="border-0 mb-3 w-80"
                    />
                    <button
                      onClick={onAdd}
                      className="submit-btn p-1"
                      style={{ minWidth: "100px" }}
                    >
                      {groupName?.id ? "Edit" : "Add"}
                    </button>
                  </div>
                  {groupNames?.length > 0 && (
                    <ul
                      className="input-border overflow-scroll mt-2"
                      style={{ minHeight: "50px", maxHeight: "100px" }}
                    >
                      {groupNames?.map((item, index) => (
                        <li
                          key={index}
                          className="d-flex as-js gap-3 mt-2"
                          // draggable
                          onDragStart={() => (dragItem.current = index)}
                          onDragEnter={() => (dragOverItem.current = index)}
                          onDragEnd={handleGroupSort}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <img src={arrow_icon} className="bullet-btn" alt="" />
                          <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                            {item?.name}
                          </p>
                          {item?.id && (
                            <img
                              src={edit_icon}
                              className="delete-btn"
                              onClick={() => handleGroupEdit(item)}
                              alt="delete"
                            />
                          )}
                          <button
                            onClick={() => {
                              setGroupNames((prev) =>
                                prev.map((i) =>
                                  i?.id === item?.id
                                    ? { ...i, status: !item?.status }
                                    : i,
                                ),
                              );
                            }}
                            style={{ minWidth: "100px" }}
                            className={`btn white border border-1 rounded-2 px-3 py-1 text-nowrap ${item?.status ? "bg-primary1" : "bg-danger"}`}
                          >
                            {item?.status ? "Active" : "De-active"}
                          </button>

                          <img
                            src={delete_icon}
                            className="delete-btn"
                            onClick={() =>
                              item?.id
                                ? setDeleteGroup({ index: index, ...item })
                                : handleRemove(index, item)
                            }
                            alt="delete"
                          />
                          <img src={drag} className="delete-btn" alt="delete" />
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex ac-je px-2">
              <button onClick={handleSubmit} className="submit-btn f2 w-40 p-2">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {(selected.type === "delete" || deleteGroup) && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(
              deleteGroup
                ? deleteGroup?.active_video
                : selected?.data?.active_video,
            ) && (
              <p className="text-danger mb-2 mt-2">
                This Category has mapped videos.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() =>
                  deleteGroup
                    ? handleRemove(deleteGroup?.index, deleteGroup)
                    : handleDelete(selected?.data)
                }
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() =>
                  deleteGroup ? setDeleteGroup(false) : handleClosePop()
                }
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialCategories;
